import { Ability } from '@casl/ability'
import { initialAbility, updateAbility } from './config'

const existingAbility = updateAbility()

export default new Ability(existingAbility || initialAbility)
